module.exports = __webpack_public_path__ + "static/media/Salesforce Video.4c2df96b.webm";